export default __webpack_public_path__ + "static/media/contact_bg_qianli.85b6cde9.jpg";